/** Normalize optional collections, but never turn malformed required data into a menu. */
export function normalizeMenuResponse(data: any): any {
  if (!data || !data.StoreResponse || typeof data.StoreResponse !== 'object' || Array.isArray(data.StoreResponse)) {
    throw new Error('Invalid store menu response: StoreResponse is required');
  }
  for (const key of ['storeMenuData', 'StoreItemStats']) {
    if (data[key] == null) data[key] = [];
    if (!Array.isArray(data[key])) throw new Error(`Invalid store menu response: ${key} must be an array`);
  }
  for (const menu of data.storeMenuData) {
    if (!menu || typeof menu !== 'object') throw new Error('Invalid menu');
    if (menu.menuSets == null) menu.menuSets = [];
    if (!Array.isArray(menu.menuSets)) throw new Error('Invalid menu sets');
    for (const set of menu.menuSets) {
      if (!set || typeof set !== 'object') throw new Error('Invalid menu set');
      if (set.menuCatgs == null) set.menuCatgs = [];
      if (!Array.isArray(set.menuCatgs)) throw new Error('Invalid menu categories');
      for (const category of set.menuCatgs) {
        if (!category || typeof category !== 'object' || (category.menuItems != null && !Array.isArray(category.menuItems))) {
          throw new Error('Invalid menu category');
        }
      }
    }
    if (menu.menuSets.some(set => set.menuCatgs.some(category => category.menuItems?.length)) && !menu.currency?.code) {
      throw new Error('Invalid menu currency');
    }
  }
  return data;
}
